// Admin component constants and shared utilities
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CATEGORY_LABELS = {
    move_well: 'Move Well',
    connect_well: 'Connect Well',
    create_well: 'Create Well',
    feel_well: 'Feel Well',
    explore_well: 'Explore Well',
    celebrate_well: 'Celebrate Well'
};

export const CATEGORY_OPTIONS = [
    { value: 'move_well', label: 'Move Well' },
    { value: 'connect_well', label: 'Connect Well' },
    { value: 'create_well', label: 'Create Well' },
    { value: 'feel_well', label: 'Feel Well' },
    { value: 'explore_well', label: 'Explore Well' },
    { value: 'celebrate_well', label: 'Celebrate Well' }
];

export const formatDateTime = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleString('en-GB', { 
        day: 'numeric', 
        month: 'short', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const getCategoryColor = (category) => {
    const colors = {
        move_well: 'bg-green-100 text-green-700',
        connect_well: 'bg-blue-100 text-blue-700',
        create_well: 'bg-purple-100 text-purple-700',
        feel_well: 'bg-pink-100 text-pink-700',
        explore_well: 'bg-amber-100 text-amber-700',
        celebrate_well: 'bg-red-100 text-red-700'
    };
    return colors[category] || 'bg-gray-100 text-gray-600';
};
